module.exports = "/_next/static/images/d6c0eb73ff5a64879c28a221d55507bb-nuconta-inclined-device@2x.png.webp";